// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ds-3";
export var flatBottomCorners = "_ds-5";
export var productImage = "_ds-0";
export var quantityContainer = "_ds-2";
export var quantityHeader = "_ds-6";
export var tooltip = "_ds-1";
export var wrapAndEllipsesOverflow = "_ds-4";